import React, { useContext, useState } from "react";
import './Header.css';
import logo from '../../Assest/LogoHeader.png';
import { NavLink } from "react-router-dom";
import { TiThMenu } from "react-icons/ti";
import LoginContext from "../../Component/Context/LoginContext";

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const { infoUser, setInfoUser } = useContext(LoginContext)

    console.log('loginContext: ', infoUser)

    const handleLogout = () => {
        setInfoUser({
            isLoged: false,
            usuario: "unknow",
            firma: "unknow",
        })
    }

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false); // Asegura que el menú se cierre
    };

    return (
        <div className="containerHeader">
            <NavLink className="navLinks" to="/Inicio" onClick={closeMenu}>
                <div className="containerLogoHeader">
                    <img src={logo} alt="logo" className="logoHeard" />
                </div>
            </NavLink>
            <div className={`menuHeader ${menuOpen ? "active" : ""}`}>
                <NavLink className="navLinks" to="/Inicio" onClick={closeMenu}>
                    <p className="optionsHeader">Inicio</p>
                </NavLink>
                <NavLink className="navLinks" to="/Quienes_Somos" onClick={closeMenu}>
                    <p className="optionsHeader">¿Quienes somos?</p>
                </NavLink>
                <NavLink className="navLinks" to="/Comunicaciones" onClick={closeMenu}>
                    <p className="optionsHeader">Comunicaciones</p>
                </NavLink>
                <NavLink className="navLinks" to="/Contactanos" onClick={closeMenu}>
                    <p className="optionsHeader">Contáctanos</p>
                </NavLink>
                <NavLink className="navLinks" to="/Agendar" onClick={closeMenu}>
                    <p className="optionsHeader">Servicios</p>
                </NavLink>
                <NavLink className="navLinks" to="/PQRS" onClick={closeMenu}>
                    <p className="optionsHeader">PQRS</p>
                </NavLink>
                {infoUser?.usuario?.nombres ? (
                    <p className="optionsHeader">{infoUser.usuario.nombres}</p>
                ) : (
                    ""
                )}
            </div>
            <div className="hamburgerMenu">
                <TiThMenu onClick={toggleMenu} />
            </div>
            {infoUser.isLoged === true ? (
                <NavLink className="navLinks" to="/Inicio_de_sesion" onClick={closeMenu}>
                    <div onClick={handleLogout} className="enterButtonHeader">
                        <p className="optionEnter">Salir</p>
                    </div>
                </NavLink>
            ) : (
                <NavLink className="navLinks" to="/Inicio_de_sesion">
                    <div className="enterButtonHeader">
                        <p className="optionEnter">Ingresar</p>
                    </div>
                </NavLink>
            )}
        </div>
    );
}

export default Header;
